import { BasicRequest } from "./basicRequest";

export class PreviewTransformationRequest extends BasicRequest{
    public transformationDefinitionId!:number;

    constructor(){
        super();
    }
}